const hyphens = {
  name: "hyphens",
  path: "/hyphens",
  title: "hyphens",
  description: "Utilities for controlling automatic hyphenation of words.",
  value: {
    "hyphens": {
      "hyphens-none": "none",
      "hyphens-manual": "manual",
      "hyphens-auto": "auto"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="hyphens-none w-48 border border-color-gray-200 p-4">Antidisestablishmentarianism is often cited as one of the longest words in the English language.</p>
<p class="hyphens-manual w-48 border border-color-gray-200 p-4">Anti&shy;dis&shy;estab&shy;lish&shy;men&shy;tar&shy;i&shy;an&shy;ism is often cited as one of the longest words in the English language.</p>
<p class="hyphens-auto w-48 border border-color-gray-200 p-4">Antidisestablishmentarianism is often cited as one of the longest words in the English language.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">hyphens-none</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">hyphens-manual</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">hyphens-auto</code> to control hyphenation.
      </p>
      <div class="space-y-6 max-w-xs">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">hyphens-none</small>
          <p class="hyphens-none w-48 border border-color-gray-200 p-4">Antidisestablishmentarianism is often cited as one of the longest words in the English language.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">hyphens-manual</small>
          <p class="hyphens-manual w-48 border border-color-gray-200 p-4">Anti&shy;dis&shy;estab&shy;lish&shy;men&shy;tar&shy;i&shy;an&shy;ism is often cited as one of the longest words in the English language.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">hyphens-auto</small>
          <p class="hyphens-auto w-48 border border-color-gray-200 p-4">Antidisestablishmentarianism is often cited as one of the longest words in the English language.</p>
        </div>
      </div>
      `
    }
  ]
};

export default hyphens;